import React from 'react';
import { FaClock, FaDownload, FaStopwatch } from 'react-icons/fa';
import { ContainerLocationStatus } from '@/utils/containerLocation';
import i18n, { getDateFormatOptions } from '@/utils/i18n';
import { useHistory } from 'react-router-dom';
import { Button } from 'reactstrap';
import { download } from '@/utils/download';
import { IUserLocation } from './types';
import { Routes } from '@/utils/routes';

interface UserContainersDisplayProps {
  locations: IUserLocation[];
  userId: string;
}

const UserContainersDisplay: React.FC<UserContainersDisplayProps> = ({
  locations,
  userId,
}) => {
  const history = useHistory();

  if (locations.length === 0) {
    return <p>{i18n.t('Users:noContainersCheckedOut')}</p>;
  }

  const activeContainers = locations.filter(
    (location) => location.status !== ContainerLocationStatus.Lost,
  );

  const lostContainers = locations.filter(
    (location) => location.status === ContainerLocationStatus.Lost,
  );

  const handleContainerClick = (containerId: string) => {
    history.push(Routes.container(containerId));
  };

  function exportCSV() {
    const csv = [['Id', 'Name', 'At User Since', 'Return Deadline', 'Status']];

    locations.forEach((cl) => {
      csv.push([
        cl.containerId,
        cl.containerName,
        new Date(cl.ownerSince).toLocaleDateString(
          i18n.language,
          getDateFormatOptions(true),
        ),
        new Date(cl.returnDeadline).toLocaleDateString(
          i18n.language,
          getDateFormatOptions(true),
        ),
        ContainerLocationStatus[cl.status],
      ]);
    });

    const csvContent = csv.map((row) => row.join(';')).join('\n');

    download(
      new Blob([csvContent], { type: 'text/csv' }),
      `ContainerExport_${userId}_${new Date().toISOString()}.csv`,
    );
  }

  return (
    <>
      <Button className="float-end" onClick={() => exportCSV()}>
        <FaDownload className="me-1" />
        Download
      </Button>
      <br className="clear-both mb-2" />
      <br />
      {/* Active Containers */}
      {activeContainers.map((location) => (
        <div
          key={`container${location.id}`}
          className="border-secondary mb-3 rounded border p-3"
          style={{ cursor: 'pointer' }}
          onClick={() => handleContainerClick(location.containerId)}
        >
          <h5 className="d-flex align-items-center">
            <FaClock className="me-2" />
            {new Date(location.ownerSince).toLocaleDateString(
              i18n.language,
              getDateFormatOptions(true),
            )}{' '}
            {location.containerName}
          </h5>
          <h5>
            <FaStopwatch className="me-2" />
            {new Date(location.returnDeadline).toLocaleDateString(
              i18n.language,
              getDateFormatOptions(true),
            )}
          </h5>
          <h5>{'Status: ' + ContainerLocationStatus[location.status]}</h5>
          <h6>{location.containerId}</h6>
        </div>
      ))}

      {/* Lost Containers Section */}
      {lostContainers.length > 0 && (
        <>
          <h4>Lost Containers</h4>
          <p>User will not be charged and container is not shown to the user</p>
          {lostContainers.map((location) => (
            <div
              key={`container${location.id}`}
              className="border-secondary mb-3 rounded border p-3"
              style={{ cursor: 'pointer' }}
              onClick={() => handleContainerClick(location.containerId)}
            >
              <h5 className="d-flex align-items-center">
                <FaClock className="me-2" />
                {new Date(location.ownerSince).toLocaleDateString(
                  i18n.language,
                  getDateFormatOptions(true),
                )}{' '}
                {location.containerName}
              </h5>
              <h5>{'Status: ' + ContainerLocationStatus[location.status]}</h5>
              <h6>{location.containerId}</h6>
            </div>
          ))}
        </>
      )}
    </>
  );
};

export default UserContainersDisplay;
